import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem('token');
  const logoutTimestamp = localStorage.getItem('logout');
  const [hasLoggedOut, setHasLoggedOut] = useState(false);
  const location = useLocation();

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      if (!decoded.exp) return true;

      const currentTime = Date.now() / 1000; 
      return decoded.exp < currentTime;
    } catch (error) {
      console.error("Invalid token:", error);
      return true;
    }
  };

  useEffect(() => {
    if (!token || logoutTimestamp || isTokenExpired(token)) {
      setHasLoggedOut(true);
    }
  }, [token, logoutTimestamp]);

  if (!token || hasLoggedOut) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
